import dynamic from 'next/dynamic';
import { forwardRef, useRef, useCallback, useImperativeHandle } from 'react';
import type { MutableRefObject, FC } from 'react';
import { Viewer as IViewer, ViewerProps } from '@toast-ui/react-editor';
import { TuiViewerWithForwardedProps } from './tuiViewerInterface';

interface ViewerPropsWithHandlers extends ViewerProps {
  onChange?(value: string): void;
}

const Viewer = dynamic<TuiViewerWithForwardedProps>(() => import('./tuiViewerCore'), { ssr: false });
const ViewerWithForwardedRef = forwardRef<IViewer | undefined, ViewerPropsWithHandlers>((props, ref) => {
  return (
    <Viewer
      {...props}
      forwardedRef={ref as MutableRefObject<IViewer>}
      initialValue={props.initialValue || ""}
    />
  );
});
ViewerWithForwardedRef.displayName = 'Viewer';

export type {
  IViewer
}
export default ViewerWithForwardedRef;
